import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/success.png'


const _hoisted_1 = { class: "success-info" }
const _hoisted_2 = { class: "order-info" }
const _hoisted_3 = { class: "price" }

import { PropType } from 'vue';
import { Button } from 'ant-design-vue';
import { ORDER_PAGE_STATUS, OrderInfo } from '../utils/config';
import { handleResultStatus } from '../utils/method';


export default /*@__PURE__*/_defineComponent({
  __name: 'Paid',
  props: {
  orderData: {
    type: Object as PropType<OrderInfo>,
    required: true,
  },
  changePaymentStatus: {
    type: Function as PropType<(status: ORDER_PAGE_STATUS) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// 订单已成功支付
const paid = () => {
  handleResultStatus(props.orderData.succRedirect);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      class: "icon"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "message" }, "支付成功", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, "订单号：" + _toDisplayString(__props.orderData.orderNo), 1),
      _createElementVNode("div", _hoisted_3, "支付金额：" + _toDisplayString(__props.orderData.price), 1)
    ]),
    _createVNode(_unref(Button), {
      type: "primary",
      class: "complete-btn",
      onClick: paid
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" 支付完成 ")
      ])),
      _: 1,
      __: [0]
    })
  ]))
}
}

})